// extracted by mini-css-extract-plugin
export default {"container":"_070c903188c3c7ad"};